import { createCullableNode } from '../utils/createCullableNode.mjs';
import { getInternalRouter } from '../utils/getInternalRouter.mjs';

/**
 * Set the page title.
 * @usage ./PageTitle.usage.md
 */
const PageTitle = ({ noSuffix }, children, utils) => {
    const router = getInternalRouter();
    let title = '';
    utils.forEach(children, (node, i) => {
        title += typeof children[i] === 'string' ? children[i] : node.vtext;
    });
    return createCullableNode(router.action(() => {
        router.setDocumentTitle(title, !!noSuffix);
    }), utils);
};

export { PageTitle };
